import React from 'react';
import { Container } from 'reactstrap';

const AdministrativeSetup = () => {
    return (
        <>
        
    <div className="container-fluid px-5 mb-3" >
      

      <header className=" mt-3 pt-3">
        <h3>Administrative Setup</h3>

      </header>
      <section className="content pb-3" style={{textAlign:'justify' }}>
        </section>
        </div>
        </>
    );
};

export default AdministrativeSetup;
